import cn from 'classnames';

import styles from './Notices.module.scss';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

interface INoticeProps {
  notice?: string;
  noticeType?: NoticeTypesEnum;
  onClose: () => void;
}

export const Notice = ({ notice, noticeType, onClose }: INoticeProps) => {
  const map = {
    [NoticeTypesEnum.SUCCESS]: styles.success,
    [NoticeTypesEnum.WARNING]: styles.warning,
    [NoticeTypesEnum.ERROR]: styles.error,
  };

  const currentClass = noticeType && map[noticeType];

  return (
    <div className={cn(styles.Notification, currentClass)}>
      <button type="button" className={styles.close} data-dismiss="alert" aria-label="Close" onClick={onClose}>
        ×
      </button>
      <p className={styles.NotificationText}>{notice}</p>
    </div>
  );
};
